var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: #1d1d1b;\n      }\n    ")),React.createElement("path",{"className":"a","d":"M6.59.64V12.71l4.15-4.46a.62.62,0,0,1,.87,0l0,0a.69.69,0,0,1,0,.94L6.42,14.8a.6.6,0,0,1-.86,0l0,0L.19,9.18a.7.7,0,0,1,0-.95.6.6,0,0,1,.86,0l0,0L5.32,12.7V.64a.64.64,0,1,1,1.27,0","key":1})]);
}

ArrowDown.defaultProps = {"viewBox":"0 0 11.83 15"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
